export default {"src":"/_next/static/media/Solana.0683e1d8.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};